import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import {
  customElement,
  query,
  queryAssignedElements,
  property,
} from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import globalStyles from './pc-insight-hero.lightDom.css.lit';

import componentStyles from './pc-insight-hero.css.lit';
import '../pc-container/pc-container';
import '../pc-animation/pc-animation';

/**
 * Insight hero component
 * @element pc-insight-hero
 * @slot - This element has a default slot
 */
@customElement('pc-insight-hero')
export class PCInsightHero extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  @query('slot')
  defaultSlot!: HTMLSlotElement;

  @queryAssignedElements({ slot: 'image' })
  imageRef: Array<HTMLElement>;

  @property({ type: Boolean, reflect: true })
  hasImage: boolean;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  firstUpdated() {
    this.hasImage = !!this.imageRef.length;
    setTimeout(() => {
      this.setAttribute('loaded', 'loaded');
    }, 300);
  }

  render(): TemplateResult {
    return html`
      <div class="insight-hero">
        <pc-container>
          <div class="left-side">
            <slot name="nav"></slot>
            <div class="content">
              <slot name="metadata"></slot>
              <slot></slot>
            </div>
          </div>
          <div class="right-side">
            <slot class="insight-hero--image-slot" name="image"></slot>
            ${this.hasImage ? null : this.animationTemplate()}
          </div>
        </pc-container>
      </div>
    `;
  }

  animationTemplate() {
    return html`<pc-animation name="variant-4"></pc-animation>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-insight-hero': PCInsightHero;
  }
}
